import { useEffect, useState } from "react";
import useAxios from "../utils/useAxios";

const useMentors = () => {
  const [mentors, setMentors] = useState([]);
  const [loading, setLoading] = useState(true);

  const axiosAPI = useAxios();

  useEffect(() => {
    async function fetchMentors() {
      try {
        const response = await axiosAPI.get("/api/mentor");
        setMentors(response.data.data);
      } catch (error) {
        console.error("Error fetching mentors:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchMentors();
  }, []);

  return { loading, mentors };
};

export { useMentors };
export default useMentors;
